import React, { useRef, forwardRef, useState, useEffect } from 'react'
import { useLoader, useFrame } from '@react-three/fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { THREE } from 'expo-three'

import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

import modelObj from '../../../assets/round_base/towerRound_base.obj'
import modelMtl from '../../../assets/round_base/towerRound_base.mtl'


const loaderObj = new OBJLoader();
const loaderMtl = new MTLLoader();
const loaderTxt = new THREE.TextureLoader();

// const mapImage = loaderTxt.load(require('../../../assets/textures/cone.png'));
// const assetURL = 'https://raw.githubusercontent.com/Cosmitar/threejs_assets/master/ufo_ships/enemy_ufoPurple.glb'

const getGradientMap = color => {
  const alphaIndex = 1
  const colors = new Uint8Array( alphaIndex + 2 )

  for ( let c = 0; c <= colors.length; c ++ ) {

    colors[ c ] = ( c / colors.length ) * 256;

  }

  const gradientMap = new THREE.DataTexture( colors, colors.length, 1, THREE.LuminanceFormat );
  gradientMap.minFilter = THREE.NearestFilter;
  gradientMap.magFilter = THREE.NearestFilter;
  gradientMap.generateMipmaps = false;
  return gradientMap
}

const textureLoader = new THREE.TextureLoader()

export default forwardRef((props, ref) => {
  const fwdRef = ref || useRef()
  const [geometry, setGeometry] = useState()
  const [materialOffsetDirection, setMaterialOffsetDirection] = useState(1)
  const { colorPalette = [], ...moreProps } = props

  const threeTone = textureLoader.load(require('../../../assets/threeTone.jpg'));
  threeTone.minFilter = THREE.NearestFilter;
  threeTone.magFilter = THREE.NearestFilter;
  
  const matTest = new THREE.MeshBasicMaterial({ color: 'lime' })
  const materialChassis = colorPalette[0] ? new THREE.MeshToonMaterial({ color: colorPalette[0], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  const materialDeco = colorPalette[1] ? new THREE.MeshToonMaterial({ color: colorPalette[1], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  const materialCore = colorPalette[2] ? new THREE.MeshToonMaterial({ color: colorPalette[2], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  const materialDome = colorPalette[3] ? new THREE.MeshToonMaterial({ color: colorPalette[3], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })

  const loadObject = async () => {
    const mtl = loaderMtl.parse(modelMtl)
    mtl.preload();
    loaderObj.setMaterials(mtl)
    const obj = loaderObj.parse(modelObj)
    obj.children[0].material[0] = materialDeco// red
    obj.children[0].material[1] = materialChassis// stone
    obj.children[0].material[2] = materialDome// stoneDark
    setGeometry(obj)
  }

  useEffect(loadObject,[])

  // useFrame(() => {
  //   if (mapImage.offset) {
  //     mapImage.wrapS = THREE.RepeatWrapping;
  //     mapImage.wrapT = THREE.RepeatWrapping;
  //     if(mapImage.offset.y > 0.9) { 
  //       mapImage.offset.y = -0.5
  //       // mapImage.offset.x = mapImage.offset.y = -0.5
  //       // setMaterialOffsetDirection(-1)
  //     }
  //     // if(mapImage.offset.x < -0.5 && materialOffsetDirection < 0) { 
  //     //   setMaterialOffsetDirection(1)
  //     // }
  //     mapImage.offset.x += (0.002 * materialOffsetDirection)
  //     // mapImage.offset.y += (0.002 * materialOffsetDirection)
  //   }
  //   // if (fwdRef.current && fwdRef.current.children[1]) {
  //   //   // fwdRef.current.children[1].rotation.y += 0.02
  //   // }
  // })
  var materials = [
    new THREE.MeshLambertMaterial( { /*map: mapImage,*/ transparent: true, color: colorPalette[0], side: THREE.DoubleSide } ),
    new THREE.MeshLambertMaterial( { transparent: true, opacity: 0 } ),
    new THREE.MeshLambertMaterial( { transparent: true, opacity: 0 } )
];
  return (
    <group
      ref={fwdRef}
      {...moreProps}
    >
      {geometry &&
        <primitive object={geometry} />
      }
      <mesh
        rotation={[Math.PI, 0, 0]}
        position={[0, 0.5, 0]}
        material={materials}
      >
        <coneBufferGeometry args={[0.5, 1.5, 32]}/>
        {/* <meshLambertMaterial opacity={1} color={colorPalette[0]} transparent map={mapImage} alphaTest={0.1} /> */}
        {/* <meshLambertMaterial color={colorPalette[0]} opacity={0.3} transparent /> */}
      </mesh>
    </group>
  )
})